import React from 'react';
import { HTMLTrans } from '../Common/Translations';
import { localiseAmount, roundCurrency } from '../Common/Helper';

export const hasAccountMenuData = (WrappedComponent) => {
  return (props) => {
    const {
      t,
      globalShippingCreditEnabled,
      shippingCreditBalance,
      shippingCreditCurrency,
      userHeaderInfo: { creditBalance },
    } = props;

    const formattedCreditBalance = formatAmount(creditBalance, shippingCreditCurrency);
    const formattedShippingCreditBalance = formatAmount(shippingCreditBalance, shippingCreditCurrency);

    const globalShippingCreditMenuItems = [
      {
        label: (
          <HTMLTrans id="navbar.navdata_credit" variables={{balance: formattedCreditBalance}}>
            Credit: <span className="text-blue">{formattedCreditBalance}</span>
          </HTMLTrans>
        ),
        url: '#',
        id: 'creditLink',
      },
    ];

    const myAccountMenuItems = [{
        label: t("navbar.navdata_myprojects", "My Projects"),
        url: '/account/dashboard/project',
        id: 'myProjects'
      }, {
        label: t("navbar.navdata_myorders", "My Orders"),
        url: '/account/dashboard/order',
        id: 'myOrderLink'
      }, {
        label: t("navbar.navdata_myvouchers", "My Vouchers"),
        url: '/account/dashboard/voucher',
        id: 'myVoucherLink'
      }, {
        label: t("navbar.navdata_accountinformation", "Account Information"),
        url: '/account/dashboard/personal',
        id: 'accountInformation'
      }, {
      label: t("navbar.navdata_ephotobook", "Share It"),
      url: "/account/dashboard/ephotobook",
      id: "ephotobook",
    }, {
        label: t("navbar.navdata_logout", "Log Out"),
        url: '/account/logout',
        id: 'logOutMenuItem'
      }];

    if (globalShippingCreditEnabled) {
      globalShippingCreditMenuItems[0].url = '/account/dashboard/credit';

      globalShippingCreditMenuItems.push({
        label: (
          <HTMLTrans id="navbar.navdata_shippingcredit" variables={{balance: formattedShippingCreditBalance}}>
            Shipping Credit: <span className="text-blue">{formattedShippingCreditBalance}</span>
          </HTMLTrans>
        ),
        url: '/account/dashboard/credit',
        id: 'shippingCreditLink',
      });

      myAccountMenuItems.splice(3, 0, {
        label: t("navbar.navdata_mycredits", "My Credits"),
        url: '/account/dashboard/credit',
        id: 'myCreditLink',
      });
    }

    return <WrappedComponent {...props} data={myAccountMenuItems} globalShippingCreditMenuItems={globalShippingCreditMenuItems} />;
  }
}

function formatAmount(amount, currency) {
  return `${currency} ${localiseAmount(roundCurrency(amount))}`;
}



// WEBPACK FOOTER //
// ./src/Nav/NavData.js